module.exports = __webpack_public_path__ + "img/share.56f3f5f0.png";